import { render, staticRenderFns } from "./IconMenuPlaylists.vue?vue&type=template&id=5e32a028&"
import script from "./IconMenuPlaylists.vue?vue&type=script&lang=js&"
export * from "./IconMenuPlaylists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e32a028')) {
      api.createRecord('5e32a028', component.options)
    } else {
      api.reload('5e32a028', component.options)
    }
    module.hot.accept("./IconMenuPlaylists.vue?vue&type=template&id=5e32a028&", function () {
      api.rerender('5e32a028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuPlaylists.vue"
export default component.exports